export default __webpack_public_path__ + "static/logo-6d7fcf37a15a3440965955c017a8f06d.svg";